export class UpdatePassword {
    constructor (
        public FirstName: string = '',
        public LastName: string = '',
        public Email: string = '',
        public Password: string = '',
        public ExistingPassword: string = ''
    ) { }
}
